"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("./styles.scss");
require("iconify-icon");
const vue_1 = __importDefault(require("vue"));
const bootstrap_vue_1 = require("bootstrap-vue");
const splitpanes_1 = require("splitpanes");
const vue_router_tab_1 = __importDefault(require("vue-router-tab"));
const portal_vue_1 = __importDefault(require("portal-vue"));
const vue2_datepicker_1 = __importDefault(require("vue2-datepicker"));
const vue_select_1 = __importDefault(require("vue-select"));
const modal_1 = require("./modal");
const plugin_1 = require("./notification/plugin");
const vue_sse_1 = __importDefault(require("vue-sse"));
const vue2_1 = require("@iconify/vue2");
const vue_virtual_scroller_1 = __importDefault(require("vue-virtual-scroller"));
const components = __importStar(require("./all"));
vue_1.default.use(bootstrap_vue_1.BootstrapVue, {
    BNavItem: {
        activeClass: 'active',
        exactActiveClass: 'active'
    },
    BDropdownItem: {
        activeClass: 'active',
        exactActiveClass: 'active'
    }
});
vue_1.default.use(bootstrap_vue_1.IconsPlugin);
vue_1.default.use(vue_router_tab_1.default);
vue_1.default.use(portal_vue_1.default);
vue_1.default.use(modal_1.ModalPlugin);
vue_1.default.use(plugin_1.NotificationPlugin);
vue_1.default.use(vue_sse_1.default);
vue_1.default.use(vue_virtual_scroller_1.default);
vue_1.default.component('Icon', vue2_1.Icon);
vue_1.default.component('Splitpanes', splitpanes_1.Splitpanes);
vue_1.default.component('Pane', splitpanes_1.Pane);
vue_1.default.component('VSelect', vue_select_1.default);
vue_1.default.component('DatePicker', vue2_datepicker_1.default);
Object.entries(components).forEach(([key, value]) => vue_1.default.component(key, value));
//# sourceMappingURL=index.js.map